import { MapTo } from '@adobe/aem-react-editable-components';
import MultiOfferBlock, { MultiOfferBlockEditConfig } from './MultiOfferBlock';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/multi-offer-block',
)(MultiOfferBlock, MultiOfferBlockEditConfig);